import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { LockIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="oferta" className="py-24 px-4 relative overflow-hidden" data-id="element-96">
      {/* Dramatic Background */}
      <div className="absolute inset-0 bg-[#0a0a0f]" data-id="element-97"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-[radial-gradient(circle,rgba(0,212,255,0.15)_0%,rgba(10,10,15,1)_70%)] pointer-events-none" data-id="element-98"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-100">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-white mb-6 leading-tight" data-id="element-101">
            Recupera el control de tu cuerpo{' '}
            <span className="text-[#00d4ff] text-glow-cyan" data-id="element-102">hoy mismo.</span>
          </h2>
          <p className="text-xl text-[#a0a0b0] font-inter max-w-2xl mx-auto" data-id="element-103">
            No esperes a que el próximo atracón te quite la energía. Obtén el
            protocolo completo y comienza tu reinicio de 72 horas ahora.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="relative max-w-md mx-auto mb-12" data-id="element-104">
          <div className="absolute -inset-10 bg-[#00d4ff]/20 blur-3xl rounded-full z-0" data-id="element-105"></div>
          <img src="https://cdn.magicpatterns.com/uploads/gerDuCv8MBAqVKN592Cger/heylloyd-image-1773970445727.png" alt="Protocolo Adiós Azúcar" className="relative z-10 w-full h-auto rounded-xl shadow-2xl border border-[#00d4ff]/30" data-id="element-106" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-107">
          <div id="precio" className="bg-[#161622] border border-[#f5a623]/30 rounded-2xl px-8 py-6 mb-8 inline-block shadow-[0_0_20px_rgba(245,166,35,0.1)]" data-id="element-108">
            <p className="text-[#a0a0b0] font-inter text-sm uppercase tracking-wider mb-2" data-id="element-109">
              Precio de Intervención Rápida
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-110">
              <p className="text-2xl font-bold font-inter text-[#a0a0b0] line-through" data-id="element-111">
                $17
              </p>
              <p className="text-5xl font-bold font-inter text-[#00c853] text-glow-cyan" data-id="element-112">
                $6.39
              </p>
            </div>
            <p className="text-[#00c853] font-inter text-sm font-semibold mt-2 uppercase tracking-wider" data-id="element-113">
              🔥 ¡Descuento especial activo!
            </p>
          </div>

          <CTAButton className="w-full md:w-auto text-xl md:text-2xl py-5 px-12 mb-6" data-id="element-114">
            ¡QUIERO DETENER MIS ANTOJOS AHORA!
          </CTAButton>

          <div className="flex items-center justify-center gap-2 text-[#a0a0b0] font-inter text-sm" data-id="element-115">
            <LockIcon className="w-4 h-4" data-id="element-116" />
            <span data-id="element-117">Acceso instantáneo después del pago seguro.</span>
          </div>
        </motion.div>
      </div>
    </section>;
}